import React from 'react'
import Header from '../Header/Header'
import DeliveryCharge from './Components/DeliveryCharge'
import Footer from '../Footer/Footer'

export const Charges = () => {
    return (
        <div>
            <Header/>
            <DeliveryCharge />
            <Footer />
        </div>
    )
}
export default Charges;